var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-btn-wrapper"},[_c('button',{staticClass:"auth-close-btn",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("@/assets/images/auth/close.svg"),"alt":"close-button"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }